import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  parentContainer: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  },
  container: {
    padding: 24,
    alignItems: 'center',
    width: '100%',
    height: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    justifyContent: 'center'
  },
  bottomButton: {
    flexDirection: 'row',
    justifyContent: 'space-between'
  }
});
export default styles;
